import {OrderParcelSize} from './consts'

export function isParcelSize(size: unknown): size is OrderParcelSize {
  return (
    typeof size === 'string' &&
    [
      OrderParcelSize.ExtraSmall,
      OrderParcelSize.Small,
      OrderParcelSize.Medium,
      OrderParcelSize.Large,
      OrderParcelSize.ExtraLarge,
      OrderParcelSize.ExtraExtraLarge,
    ].includes(size)
  )
}
